// Remember:
// Every file in scripts/ acts as an entry-point and gets tranformed to build/. Feel free to create as much as you want.
// Files in subdirectories will be ignored but you can require them in entry-point-files.
// Add an _ to a file and it will just be ignored(good for tests).
// Add your entry-point-files to templates/layout/yourlayout.html


//=require ../../libraries/jquery.3.6.0.min.js
//=require ../../libraries/lazysizes.min.js
//=require ../../libraries/lodash.js
//=require ../../libraries/jquery.fracs.js
// //=require ../../libraries/remjet.js
// //=require ../../libraries/packery.2.1.1.min.js
//=require ../../libraries/imagesLoaded.js
//=require ../../libraries/isoptope.3.0.3.min.js
//=require ../../libraries/slick-1.6.0/slick/slick.js
//=require ../../patterns/molecules/lightbox/vendors/jquery.fancybox.js
//=require ../../libraries/sumoselect/jquery.sumoselect.js
//=require ../../libraries/matchmedia-polyfill.js
//=require ../../libraries/js-cookie.js
